import React from 'react'

// Care about IDE performance. Needs to be fixed.
// ForwardRef and Generics are not very compatible, so we need to use this workaround
// See https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref for more details
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
type FixedForwardRef = <T, P = {}>(
  render: (props: P, ref: React.Ref<T>) => React.ReactNode
) => (props: P & React.RefAttributes<T>) => React.ReactNode

export const fixedForwardRef = React.forwardRef as FixedForwardRef
